import { render } from "./NotFoundComponent.vue?vue&type=template&id=3acb6040"
import script from "./NotFoundComponent.vue?vue&type=script&lang=js"
export * from "./NotFoundComponent.vue?vue&type=script&lang=js"
script.render = render

export default script